import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import officeService from "./officeService";

const initialState = {
  offices: [],
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
};

//Edit student
export const editOffice = createAsyncThunk(
  "offices/edit",
  async (officeData, thunkAPI) => {
    try {
      return await officeService.editOffice(officeData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Get user locations
export const getOffice = createAsyncThunk(
  "offices/getOne",
  async (_, thunkAPI) => {
    try {
      return await officeService.getOffice();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Get user students
export const getOffices = createAsyncThunk(
  "offices/getAll",
  async (_, thunkAPI) => {
    try {
      //console.log("In getOffices slice getAll");
      return await officeService.getOffices();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const officeSlice = createSlice({
  name: "offices",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(editOffice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(editOffice.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.offices.push(action.payload);
      })
      .addCase(editOffice.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getOffice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getOffice.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.offices = action.payload;
      })
      .addCase(getOffice.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getOffices.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getOffices.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.offices = action.payload;
      })
      .addCase(getOffices.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

export const { reset } = officeSlice.actions;
export default officeSlice.reducer;
